export const operationTypesTranslations = {
  ar: {
    title: 'أنواع القيود (العمليات)',
    add: 'إضافة نوع قيد جديد',
    edit: 'تعديل نوع قيد',
    delete: 'حذف نوع قيد',
    confirmDelete: 'هل أنت متأكد من حذف هذا النوع؟',
    confirmDeleteTitle: 'تأكيد الحذف',
    description: 'الوصف',
    descriptionEn: 'الوصف (إنجليزي)',
    isActive: 'نشط',
    isInactive: 'غير نشط',
    saveSuccess: 'تم حفظ نوع القيد بنجاح',
    deleteSuccess: 'تم حذف نوع القيد بنجاح',
  },
  en: {
    title: 'Operation Types',
    add: 'Add New Operation Type',
    edit: 'Edit Operation Type',
    delete: 'Delete Operation Type',
    confirmDelete: 'Are you sure you want to delete this type?',
    confirmDeleteTitle: 'Confirm Delete',
    description: 'Description',
    descriptionEn: 'Description (English)',
    isActive: 'Active',
    isInactive: 'Inactive',
    saveSuccess: 'Operation type saved successfully',
    deleteSuccess: 'Operation type deleted successfully',
  },
}
